import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import {
  Trade,
  activeMarginTradeStates,
  getPrimaryCcy,
  getSellCcy,
  getBuyCcy,
  formatHedgingInstrument,
} from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentTradeDetails',
  props: {
  trade: {
    type: Object as PropType<Trade>,
    required: true,
    default: () => ({}),
  },
  sellingLabel: {
    type: String,
    required: false,
    default: () => 'Selling',
  },
  buyingLabel: {
    type: String,
    required: false,
    default: () => 'Buying',
  },
},
  setup(__props) {

const props = __props;



const gbpInitialMarginValue = computed(() => {
  return props.trade.gbpInitialMarginAmount ?? 0;
});

const gbpVariationMargin = computed(() => {
  return props.trade.gbpVmm ?? 0;
});
const tradeMarginIsActive = computed(() => {
  return activeMarginTradeStates.includes(props.trade.state);
});
const gbpInUseMarginValue = computed(() => {
  if (!tradeMarginIsActive.value) {
    return 0;
  }
  return gbpVariationMargin.value + gbpInitialMarginValue.value;
});
const clientRate = computed(() => {
  return getPrimaryCcy(props.trade).clientRate;
});
const sellCcy = computed(() => {
  return getSellCcy(props.trade);
});

const buyCcy = computed(() => {
  return getBuyCcy(props.trade);
});

return { __sfc: true,props, gbpInitialMarginValue, gbpVariationMargin, tradeMarginIsActive, gbpInUseMarginValue, clientRate, sellCcy, buyCcy, formatHedgingInstrument, formatCurrencyValue, formatDate, SIMPLE_DATE_FORMAT }
}

})